/**
 * Kredit AI pod menom v menu (.524).
 *
 * Oto: „nevedelo by nám u mňa niekde pri mojom mene naľavo pod menu dole
 * ukazovať, aký je aktuálny stav kreditu?"
 *
 * Anthropic zostatok cez API neposiela, preto je to **odhad**: zostatok
 * zapísaný podľa konzoly mínus to, čo CRM odvtedy minulo. Keď Anthropic
 * otázku odmietne pre kredit, svieti načerveno „minutý" bez ohľadu na odhad.
 * Vidí to len administrátor.
 */
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Sparkles } from 'lucide-react';
import { api, dtSk } from '../api';
import { Modal, useToast } from './ui';

const usd = (n) => `${Number(n || 0).toFixed(2).replace('.', ',')} $`;
const FARBA = {
  ok: 'text-emerald-300',
  nizky: 'text-amber-300',
  minuty: 'text-red-300',
  nezname: 'text-slate-400',
};

export default function AiKredit() {
  const toast = useToast();
  const [s, setS] = useState(null);
  const [okno, setOkno] = useState(false);
  const [suma, setSuma] = useState('');
  const nacitaj = () => api.get('/api/settings/ai-kredit').then(setS).catch(() => setS(null));
  useEffect(() => {
    nacitaj();
    const t = setInterval(nacitaj, 5 * 60 * 1000);
    return () => clearInterval(t);
  }, []);
  if (!s) return null;

  const text = s.uroven === 'minuty' ? 'minutý – dobiť'
    : s.zostatok === null ? 'zadať zostatok' : `~${usd(s.zostatok)}`;
  const uloz = async () => {
    try {
      setS(await api.put('/api/settings/ai-kredit', { zostatok: suma }));
      setSuma('');
      toast.success('Zostatok uložený – odteraz sa odpočítava spotreba CRM.');
    } catch (e) { toast.error(e.message); }
  };

  return (
    <>
      <button type="button" onClick={() => { nacitaj(); setOkno(true); }}
        className="mb-1 flex w-full items-center gap-1.5 rounded-lg px-2 py-1 text-left text-xs hover:bg-slate-800"
        title="Kredit na účte Anthropic (AI) – odhad podľa spotreby CRM">
        <Sparkles size={13} className={FARBA[s.uroven]} />
        <span className="text-slate-400">AI kredit:</span>
        <span className={`font-semibold ${FARBA[s.uroven]}`}>{text}</span>
      </button>

      {okno && createPortal(<div className="text-slate-800"><Modal open={okno} onClose={() => setOkno(false)} title="Kredit AI (Anthropic)" size="max-w-md"
        footer={<button className="btn-secondary" onClick={() => setOkno(false)}>Zavrieť</button>}>
        <div className="space-y-3 text-sm">
          {s.uroven === 'minuty' && (
            <div className="rounded-lg bg-red-50 px-3 py-2 text-red-800 ring-1 ring-red-200">
              Anthropic odmietol otázku pre minutý kredit{s.minuty_kedy ? ` (${dtSk(s.minuty_kedy)})` : ''}.
              AI funkcie nepôjdu, kým sa kredit nedobije.
            </div>
          )}
          <div className="grid grid-cols-2 gap-2">
            <div className="rounded-lg bg-slate-50 p-2 ring-1 ring-slate-200">
              <div className="text-xs text-slate-500">Odhad zostatku</div>
              <div className="text-lg font-semibold">{s.zostatok === null ? '—' : usd(s.zostatok)}</div>
              {s.vydrzi_dni !== null && <div className="text-xs text-slate-500">vydrží asi {s.vydrzi_dni} dní</div>}
            </div>
            <div className="rounded-lg bg-slate-50 p-2 ring-1 ring-slate-200">
              <div className="text-xs text-slate-500">Minuté za 30 dní</div>
              <div className="text-lg font-semibold">{usd(s.za_30_dni)}</div>
              <div className="text-xs text-slate-500">{s.otazok_za_30_dni} otázok · dnes {usd(s.za_den)}</div>
            </div>
          </div>
          {s.zapisany !== null && (
            <p className="text-xs text-slate-500">
              Zapísané {usd(s.zapisany)} dňa {dtSk(s.zapisany_kedy)}, odvtedy CRM minulo ~{usd(s.minute_od_zapisu)}.
            </p>
          )}
          <p className="text-xs text-slate-500">
            Anthropic presný zostatok cez API neposiela, preto je to odhad zo spotreby CRM. Po dobití
            (alebo raz za čas) prepíšte zostatok podľa{' '}
            <a className="underline" href="https://console.anthropic.com/settings/billing" target="_blank" rel="noreferrer">
              console.anthropic.com → Billing</a>.
          </p>
          <div className="flex items-end gap-2">
            <label className="flex-1">
              <span className="text-xs text-slate-500">Zostatok v konzole teraz ($)</span>
              <input className="input mt-1" inputMode="decimal" value={suma} placeholder="napr. 20"
                onChange={(e) => setSuma(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && suma && uloz()} />
            </label>
            <button className="btn-primary" disabled={!suma} onClick={uloz}>Uložiť</button>
          </div>
        </div>
      </Modal></div>, document.body)}
    </>
  );
}
